/**
 * @generated SignedSource<<c10a3479344de239969bd1a93235453c>>
 * @relayHash 485b07e69670e84889e1c718d8693e52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 212c349f0cf0225cfd610d7a4583eaceeb584b90c8bb730b8316e6bde9ba4e2c

import type { ConcreteRequest } from 'relay-runtime';
export type WelcomeMessagesQuery$variables = Record<PropertyKey, never>;
export type WelcomeMessagesQuery$data = {
  readonly spaViewContext: {
    readonly isWelcomeMessageCustomized: boolean | null;
    readonly resourceContexts: ReadonlyArray<string | null> | null;
    readonly resourceKeys: ReadonlyArray<string | null> | null;
    readonly showEditButton: boolean | null;
    readonly showWelcomeMessageEditHint: boolean | null;
    readonly welcomeMessageEditUrl: string | null;
    readonly welcomeMessageHtml: string | null;
  } | null;
};
export type WelcomeMessagesQuery = {
  response: WelcomeMessagesQuery$data;
  variables: WelcomeMessagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SpaViewModel",
    "kind": "LinkedField",
    "name": "spaViewContext",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "welcomeMessageEditUrl"
      },
      {
        "kind": "ScalarField",
        "name": "welcomeMessageHtml"
      },
      {
        "kind": "ScalarField",
        "name": "isWelcomeMessageCustomized"
      },
      {
        "kind": "ScalarField",
        "name": "resourceKeys"
      },
      {
        "kind": "ScalarField",
        "name": "resourceContexts"
      },
      {
        "kind": "ScalarField",
        "name": "showWelcomeMessageEditHint"
      },
      {
        "kind": "ScalarField",
        "name": "showEditButton"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "WelcomeMessagesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WelcomeMessagesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "485b07e69670e84889e1c718d8693e52",
    "id": "212c349f0cf0225cfd610d7a4583eaceeb584b90c8bb730b8316e6bde9ba4e2c",
    "metadata": {},
    "name": "WelcomeMessagesQuery",
    "operationKind": "query",
    "text": "query WelcomeMessagesQuery{spaViewContext{welcomeMessageEditUrl,welcomeMessageHtml,isWelcomeMessageCustomized,resourceKeys,resourceContexts,showWelcomeMessageEditHint,showEditButton}}"
  }
};
})();

(node as any).hash = "7a7432847603f3b8c92c592f7e345430";

export default node;
